import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

type Linha = { chave: string; texto: string; original: unknown; editado: boolean };

/**
 * Editor de mapas chave -> valor (ex.: cabeçalhos HTTP do login, parâmetros do comando). Uso: [(valor)]="mapa".
 * Valores que a tela não editou voltam exatamente como chegaram (números, objetos), para não alterar dados antigos.
 */
@Component({
  selector: 'app-chave-valor',
  templateUrl: './chave-valor.component.html',
  styleUrls: ['./chave-valor.component.css']
})
export class ChaveValorComponent implements OnChanges {

  @Input() valor: Record<string, any> | null | undefined;
  @Input() rotuloChave = 'Nome';
  @Input() rotuloValor = 'Valor';
  @Input() rotuloAdicionar = 'Adicionar';
  @Input() prefixoId = 'cv';
  @Output() valorChange = new EventEmitter<Record<string, any>>();

  linhas: Linha[] = [];
  private ultimoEmitido: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['valor']) return;
    // Alteração vinda de fora (ex.: trocar de recurso); a que este componente acabou de emitir não recria as linhas
    if (JSON.stringify(this.valor ?? {}) === this.ultimoEmitido) return;
    this.linhas = Object.entries(this.valor ?? {}).map(([chave, v]) => ({
      chave, texto: typeof v === 'string' ? v : JSON.stringify(v), original: v, editado: false
    }));
  }

  adicionar(): void {
    this.linhas.push({ chave: '', texto: '', original: '', editado: true });
  }

  remover(i: number): void {
    this.linhas.splice(i, 1);
    this.emitir();
  }

  alterou(l: Linha): void {
    l.editado = true;
    this.emitir();
  }

  chaveRepetida(i: number): boolean {
    const c = this.linhas[i].chave.trim().toLowerCase();
    return !!c && this.linhas.findIndex(l => l.chave.trim().toLowerCase() === c) !== i;
  }

  private emitir(): void {
    const mapa: Record<string, any> = {};
    for (const l of this.linhas) {
      const chave = l.chave.trim();
      if (!chave) continue;
      mapa[chave] = l.editado ? l.texto : l.original;
    }
    this.ultimoEmitido = JSON.stringify(mapa);
    this.valorChange.emit(mapa);
  }
}
